import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReviewCard from "./ReviewCard/ReviewCard";
import styles from "./ReviewSection.module.scss";

interface Review {
  name: string;
  text: string;
  rating: number;
}

const ReviewsSection: React.FC = () => {
  const { t } = useTranslation("common");
  const reviews = t("reviewsSection.reviews", {
    returnObjects: true,
  }) as Review[];

  // Перевірка, чи є reviews масивом
  if (!Array.isArray(reviews)) {
    console.error("Expected reviews to be an array, but got:", reviews);
    return <div>Unable to load reviews</div>; // або інший fallback
  }

  return (
    <div className="container">
      <div className={`sideP88 titleCont ${styles.mainReviewBlock}`}>
        <div className="titleBlock halfBlock">
          <h2>{t("reviewsSection.title")}</h2>
        </div>
        <Link to="/reviews" className={styles.buttonLink}>
          <button
            className={`${styles.buttonW} commonButton buttonMd buttonWhiteBg`}
          >
            {t("reviewsSection.allReviewsButton")}
          </button>
        </Link>
      </div>

      <div className={`${styles.reviewSection} sideP88`}>
        <div className={`${styles.reviewsSection}`}>
          {reviews.map((review, index) => (
            <ReviewCard
              key={index}
              name={review.name}
              text={review.text}
              rating={review.rating}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewsSection;
